import * as angular from 'angular';
import FdxImportsShopifyInstructionsModalController from './fdx-imports-shopify-instructions-modal.controller';
import { MODULE_NAME } from '../../../../config/constants';

import './fdx-imports-shopify-instructions-modal.styles.scss';

export const componentName = 'fdxImportsShopifyInstructionsModal';

angular.module(MODULE_NAME).component(componentName, {
	template: require('./fdx-imports-shopify-instructions-modal.template.html'),
	controller: FdxImportsShopifyInstructionsModalController,
	bindings: {
		// from uibmodal
		close: '&',
		dismiss: '&',
		resolve: '<?'
	}
});